var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCurrentLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  fill: "#F1F8FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.94 5.71-4.975 12.97a.5.5 0 0 1-.465.32h-.035a.5.5 0 0 1-.45-.385l-1.43-6.2L5.385 11a.5.5 0 0 1-.065-.95l12.97-4.99a.5.5 0 0 1 .65.65Z",
  fill: "#1890FF"
})));
export default SvgCurrentLocation;